import withStyleSheets from "@client/content/Containers/withStyleSheets";
import { ImageEntity } from "@client/content/controls/Image/container";
import { type BlogList } from "@client/content/modules/BlogList/types";
import { makeButton } from "@client/content/modules/Button";
import { type ButtonContainerProps } from "@client/content/modules/Button/container";
import Heading, { type HeadingProps } from "@client/controls/HTML/Heading/component";
import Link from "@client/controls/Link/container";
import { goTo } from "@client/lib/navigation";
import { truncate } from "@client/lib/text";
import { TargetSelector } from "@client/selectors";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormatN } from "@common/lib/i18n";
import classnames from "classnames";
import moment from "moment";
import * as React from "react";
import { type BlogListItemContainerProps } from "./container";

export const Button = makeButton<ButtonContainerProps>(TargetSelector.Entity, "readMore");

const Excerpt = withStyleSheets<React.HTMLProps<HTMLParagraphElement>>(
  ({ id, ...props }) => <p {...props} />,
  ["text"],
  "excerpt"
);

const PostInfo = withStyleSheets<React.HTMLProps<HTMLParagraphElement>>(
  ({ id, ...props }) => <div {...props} />,
  ["text"],
  "postInfo"
);

export type BlogListItemProps = BlogListItemContainerProps & {
  descriptionStyle: React.CSSProperties;
  post: BlogList.Post;
  excerptLimit: number;
  noImageUrl: string;
  style: React.CSSProperties;
  titleHeading: HeadingProps;
};

const BlogListItem = ({
  descriptionStyle,
  post,
  excerptLimit,
  noImageUrl,
  style,
  titleHeading,
  ...rootProps
}: BlogListItemProps) => {
  const i18n = useI18n();

  return (
    <div className={classnames("post-item")}>
      <div className="post-item-inner" style={style}>
        <div className="post-image">
          <Link to={post.permalink}>
            <ImageEntity id={rootProps.parentId} source={rootProps.source} src={post.imageUrl ?? noImageUrl} />
          </Link>
        </div>
        <div className="post-description" style={descriptionStyle}>
          <PostInfo
            id={rootProps.parentId}
            source={rootProps.source}
            className="post-info"
            textSubSelector=".post-info"
          >
            <span>
              <i className="far fa-user" />
              {post.authorName}
            </span>
            <span>
              <i className="far fa-calendar" />
              {moment(post.publishedOnDate).format("L")}
            </span>
            <span>
              <i className="far fa-comments" />
              {i18nFormatN(post.commentCount, i18n.oneComment, i18n.nComments)}
            </span>
          </PostInfo>
          <Link to={post.permalink}>
            <Heading className="post-title" {...titleHeading} content={post.title} />
          </Link>
          <Excerpt
            className="excerpt"
            id={rootProps.parentId}
            source={rootProps.source}
            dangerouslySetInnerHTML={{ __html: truncate(post.excerpt, excerptLimit) }}
            textSubSelector=".excerpt"
          />
          <Button onClick={() => goTo(post.permalink)} {...rootProps} id={rootProps.parentId} />
        </div>
      </div>
    </div>
  );
};
export default BlogListItem;
